<div class="coll-first-menu">
    <div id="divTitle" class="fl-heading"> {{bs.getResource('rbkey_PrgrssVwLBL_App')}}</div>
    <div class="outer-div" role="main" aria-labelledby="divTitle">
        <ul class="progress-list">
            <li [ngClass]="{'hand-cursor':true,'active': tempLearningTypeID == item.LearningTypeID }"
                (click)="loadLearningList(item)"
                *ngFor="let item of summaryItems; let i=index; trackBy: trackBySummaryList">
                <div *ngIf="summaryItems && this.summaryItems.length > 0"> 
                    <div *ngIf="i%2 == 0; else redBlock" [attr.data-percent]="item.Percentage"
                        class="pie-title-center progress-circle-green"> <span class="pie-value"></span> </div>
                    <ng-template #redBlock>
                        <div [attr.data-percent]="item.Percentage" class="pie-title-center progress-circle-red"> <span
                                class="pie-value"></span> </div>
                    </ng-template>
                    <div class="canv-name">
                        {{item.LearningType}} <span>({{item.TotalLearning}})</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</div>